/**
 * Multiple-Choice phase — shows the current MC question and calls
 * `onPick(option)` when the panelist selects one. The parent advances the
 * mcIndex / persists the response.
 */
export default function ScreenMc({ mcIndex, mcQuestions, currentMc, onPick }) {
  const total = mcQuestions.length;
  return (
    <div className="min-h-screen bg-[var(--rl-bg-subtle)] flex flex-col" data-testid="mc-phase">
      <div className="px-6 py-4 border-b border-[var(--rl-border)] bg-white">
        <div className="max-w-2xl mx-auto flex items-center justify-between">
          <div className="text-xs uppercase tracking-[0.3em] font-bold text-[var(--rl-text-secondary)]">Phase 1 — Quick Questions</div>
          <div className="text-xs font-mono">{mcIndex + 1} / {total}</div>
        </div>
      </div>
      <div className="flex-1 flex items-center justify-center px-6 py-12">
        <div className="max-w-xl w-full">
          <h2 className="font-display font-black text-3xl lg:text-4xl tracking-tight leading-tight" data-testid="mc-question-text">{currentMc?.question_text}</h2>
          <div className="grid sm:grid-cols-2 gap-3 mt-8">
            {currentMc?.options?.map((opt, i) => (
              <button
                key={i}
                onClick={() => onPick(opt)}
                className="text-left p-5 bg-white border border-[var(--rl-border)] hover:border-[var(--rl-text)] hover:bg-[var(--rl-text)] hover:text-white transition-colors"
                data-testid={`mc-option-${i}`}
              >
                <span className="font-mono text-xs text-[var(--rl-text-secondary)] group-hover:text-white">0{i + 1}</span>
                <div className="font-semibold mt-2">{opt}</div>
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
